import { render } from "./CourseResourceManagementList.vue?vue&type=template&id=474514c4&scoped=true"
import script from "./CourseResourceManagementList.vue?vue&type=script&lang=js"
export * from "./CourseResourceManagementList.vue?vue&type=script&lang=js"

import "./CourseResourceManagementList.vue?vue&type=style&index=0&id=474514c4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-474514c4"

export default script